// src/utils/httpCommon.js

import axios from 'axios';

// Create an instance of axios with default configuration
const httpCommon = axios.create({
  // baseURL: 'http://localhost:8000/api', // Use environment variable or fallback URL
  baseURL: 'https://it-work.wanorn.com/backend/api', // Use environment variable or fallback URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor (Optional)
httpCommon.interceptors.request.use(
  (config) => {
    // Here you can modify the config before sending the request
    // For example, you can attach a token to every request
    const token = localStorage.getItem('token');  // or from cookies, state, etc.
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.withCredentials = true
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor (Optional)
httpCommon.interceptors.response.use(
  (response) => {
    // You can handle the response globally here, such as logging
    return response;
  },
  (error) => {
    // Handle response errors globally (e.g. token expiration, network errors)
    if (error.response) {
      // Server responded with a status outside of the 2xx range
      if (error.response.status === 401) {
        // Handle unauthorized (e.g., redirect to login page)
        console.log('Unauthorized request, redirecting to login...');
        // window.location.href = '/login'; // Example redirect
        localStorage.removeItem('token');
        window.location.reload(); 
      }
    } else if (error.request) {
      // Request was made, but no response received
      console.error('Network Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default httpCommon;
